import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { Button } from '@spcc/uikit'
import { KioskInboundSection } from '@spcc/domains/incoming-materials'

export const Route = createFileRoute('/inbound')({
  component: InboundPage,
})

function InboundPage() {
  const navigate = useNavigate()

  return (
    <div className="space-y-4">
      <Button variant="ghost" onClick={() => navigate({ to: '/' })}>
        ←
      </Button>
      <KioskInboundSection />
    </div>
  )
}
